export enum PopoverPlacement {
    Auto = 'auto',
    AutoStart = 'auto-start',
    AutoEnd = 'auto-end',
    Top = 'top',
    TopStart = 'top-start',
    TopEnd = 'top-end',
    Bottom = 'bottom',
    BottomStart = 'bottom-start',
    BottomEnd = 'bottom-end',
    Right = 'right',
    RightStart = 'right-start',
    RightEnd = 'right-end',
    Left = 'left',
    LeftStart = 'left-start',
    LeftEnd = 'left-end',
}

export enum PopoverTrigger {
    Click = 'click',
    Hover = 'hover',
    Manual = 'manual',
}

export enum PopoverStrategy {
    Absolute = 'absolute',
    Fixed = 'fixed',
}
